import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectsComponent } from './projects.component';
import { authGuard } from '../../shared/guards/auth.guard';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { CertificateOfAppreciationComponent } from './certificate-of-appreciation/certificate-of-appreciation.component';

const routes: Routes = [
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'projects/:id/certificate-of-appreciation',
    component: CertificateOfAppreciationComponent,
    canActivate: [authGuard],
  },
  {
    path: 'projects/:id',
    component: ProjectDetailsComponent,
    canActivate: [authGuard],
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectsRoutingModule { }
